/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from 'react-bootstrap-v5'
import exportStatusesDocx from './wordStatuses'

import { AccountStatuses } from './AccountStatusesBba'
import { authFetch } from '../auth/redux/AuthFetch'

type Props = {
    className: string,
    parentToChild?: any[]
    IssuerDocumentId: string
    RequesteeDocumentId: string
    selectedItem: string
    footerArticle: any
    host: any
    accessToken: any
    requestId: string
    userName: string
    //setIssuerDocumentId: React.Dispatch<React.SetStateAction<string>>
    reset(): void
}


const AccountStatusesTable: React.FC<Props> = ({ parentToChild, className, IssuerDocumentId, RequesteeDocumentId, selectedItem, footerArticle, host, accessToken, requestId, userName, reset }) => {

    let i = 0;


    const intl = useIntl();



    function generateGBbaDOCX(
        arrayStatuses: AccountStatuses[],
        issuerDocumentId: string,
        // requesteeDocumentId: string,
        // requesteeFullName: string,
        // RequesteeAddress: string,
        selectedItem: any,
        footerArticle: any,
        username: string,
        o: AccountStatuses
    ) {
        const json2xml = require('json2xml');
        const xmlData = json2xml({ legalInquiry: arrayStatuses });
        var endpoint = `${host}/legalinquiry`;
        const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ClientId: clientId,
                Authorization: accessToken,
            },
            body: JSON.stringify({
                id: requestId,
                issuerDocumentId: issuerDocumentId,
                requesteeDocumentId: '',
                requesteeFullName: 'Pravni odjel FIA',
                address: '',
                //BodyColumn: JSON.stringify(arrayStatuses.filter(x => x.validFrom >= o.validFrom)),
                BodyColumn: xmlData,
                Chargible: false,
                NumberOfRequestIDs: 1,
                NumberOfRealResponses: arrayStatuses.length,
                NumberOfImagineResponses: arrayStatuses.length === 0 ? 1 : 0,
                JIB: parentToChild ? parentToChild[0].jib : '',
                BBAN: '',
                IBAN: '',
                UserName: username,
                PayerName: '',
                PayingDate: '1900-01-01',
                EntityName: parentToChild ? parentToChild[0].entityName : '',
                TypeOfExport: 'Word pravni',
                idcodeBook: 587


            })
        };
        authFetch(endpoint, requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (response.status === 200) {
                    reset()
                    exportStatusesDocx((parentToChild as AccountStatuses[]).filter(x => x.validFrom >= o.validFrom), IssuerDocumentId, '', selectedItem, footerArticle)

                }
                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }

            })
            .catch(error => {
                alert('There was an error!');
                console.error('There was an error!', error);
            });


    }



    return (
        <div className={`card ${className}`} style={{ width: "100%", position: "relative", backgroundColor: "InfoBackground", alignSelf: "center" }}>



            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='text-dark fw-bolder text-hover-primary fs-6'>{intl.formatMessage({ id: 'LEGALINQUIRY.RESULTS' })}</span>
                </h3>
            </div>
            <div className='card-body py-3' style={{ width: "100" }}>

                <div className='table-responsive'>

                    <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3' >

                        <thead>
                            <tr className='fw-bolder text-dark'>
                                <th className="text-left">RB</th>
                                <th className="text-left">Naziv pravnog za koje je vršena pretraga</th>
                                <th className="text-left">JIB pravnog lica</th>
                                <th className="text-left">Adresa pravnog lica</th>
                                <th className="text-left">Broj glavnog računa pravnog lica</th>
                                <th className="text-left">Naziv banke kojoj pripada račun</th>
                                <th className="text-left">Tip računa</th>
                                <th className="text-left">Status glavog računa</th>
                                <th className="text-left">Datum od kada važi status računa</th>
                                <th className="text-left">Datum do kada važi status računa</th>

                            </tr>
                        </thead>

                        <tbody>
                            {parentToChild!.map(o => <tr key={`${o.number}-${o.validFrom}`}>
                                <td width="2%">
                                    <span title="Redni broj" >
                                        {i = i + 1}
                                    </span>
                                </td>
                                <td width="14%">
                                    <span title="Naziv pravnog lica" >
                                        {o.entityName ? o.entityName : ''}
                                        {/*o.fullName ? o.fullName : o.body ? 'JSON.parse(o.body).resultList[0].individualEntityName' : ''*/}
                                    </span>
                                </td>
                                <td width="7%">
                                    <span title="JIB pravnog lica" >
                                        {o.jib ? o.jib : ''}
                                    </span>
                                </td>
                                <td width="14%">
                                    <span title="Adresa pravnog lica" >
                                        {o.locatioN_ADDRESS ? o.locatioN_ADDRESS : ''}
                                    </span>
                                </td>


                                <td className="text-left" width="14%">
                                    <span title='Broj glavnog računa pravnog lica'>
                                        {o.number ? o.number : ''}
                                    </span>
                                </td>
                                <td className="text-left" width="14%">
                                    <span title='Naziv banke kojoj pripada račun'>
                                        {o.bankName ? o.bankName : ''}
                                    </span>
                                </td>
                                <td className="text-left" width="6%">
                                    <span title='Tip računa'>
                                        {o.typE_CODE ? o.typE_CODE : ''}
                                    </span>
                                </td>

                                <td width="10%">
                                    <span title="Status računa" >
                                        {o.statusValue ? o.statusValue : ''}
                                    </span>
                                </td>
                                <td width="10%">
                                    <span title="Datum od kada važi status računa">
                                        <Button size="lg" style={{ width: "100%" }} onClick={() => {
                                            //exportStatusesDocx((parentToChild as AccountStatuses[]).filter(x => x.validFrom >= o.validFrom), IssuerDocumentId, '', selectedItem, footerArticle)
                                            generateGBbaDOCX(parentToChild as AccountStatuses[], IssuerDocumentId, selectedItem, footerArticle, userName, o)
                                        }} >
                                            {o.validFrom_string ? o.validFrom_string : o.validFrom}
                                        </Button>
                                    </span>
                                </td>
                                <td width="10%" title="Datum do kada važi status računa">
                                    <span  >
                                        {o.validTo_string ? o.validTo_string : ''}
                                    </span>

                                </td>
                            </tr>)}
                        </tbody>

                    </table>

                </div>

            </div>

        </div>
    )
}

export { AccountStatusesTable }
